import { render, staticRenderFns } from "./AgentQuickResponseLoading.vue?vue&type=template&id=28b7e0fa&scoped=true&"
import script from "./AgentQuickResponseLoading.vue?vue&type=script&lang=js&"
export * from "./AgentQuickResponseLoading.vue?vue&type=script&lang=js&"
import style0 from "./AgentQuickResponseLoading.vue?vue&type=style&index=0&id=28b7e0fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7e0fa",
  null
  
)

export default component.exports